import type { Translation } from "../i18n-types";

const ca = {
	WELCOME_LONG: "Benvingut a Unicorn Digital Courtroom",
	WELCOME: "Benvingut/da {name}!",
	JOIN_ROOM_DESCRIPTION:
		"Uniu-vos a una sala de la llista següent o creeu la vostra pròpia sala!",
	NO_ROOM: "No veieu la sala que esteu buscant? Creeu la vostra pròpia sala.",
	CREATE_ROOM: "Crear Sala",
	ROOM: "Sala",
	ACCESSIBILITY_SETTINGS: "Configuració d'accessibilitat",
	ACCESSIBILITY_SETTINGS_DESCRIPTION:
		"Canvia la configuració d'accessibilitat aquí",
	CONTRAST: "Contrast",
	SELECT_DISPLAY_NAME: "Introduïu el nom que voleu utilitzar",
	SOMETHING_WENT_WRONG: "Ai, ai! Alguna cosa ha anat malament.",
	GO_BACK: "Tornar enrere",
	GO_BACK_TO_ROOM: "Tornar a la Sala",
	EXPAND: "Expandir",
	EXPORT: "Exportar",
	JOIN_ROOM: "Unir-se a la Sala",
	ROOM_ENDED_TITLE: "Sala Finalitzada",
	ROOM_ENDED_DESCRIPTION:
		"La sala ha finalitzat, se't redirigirà a la pantalla d'inici",
	RENAME_FAILED: "Error en el canvi de nom.",
	TRANSCRIPT_DISCLAIMER:
		"Una transcripció basada en els parlants identificats. Has de parlar durant més de 7 segons per ser identificat.",
	CHANGE_SPEAKER_TITLE: "Canviar Parlant",
	CHANGE_SPEAKER_DESCRIPTION: "canvia el nom i el color del parlant aquí",
	PREVIEW_MESSAGE: "Aquest és un missatge de previsualització",
	COLOR: "Color",
	NAME: "Nom",
	LANGUAGE: "Idioma",
	CANCEL: "Cancel·lar",
	SAVE: "Desar",
	ROOM_ID: "ID de la Sala",
	ROOM_ID_FORM_PLACEHOLDER: "Introdueix l'ID de la sala per unir-te",
	ROOM_ID_FORM_REQUIRED: "L'ID de la sala és obligatori per unir-te",
	ROOM_ID_FORM_MIN_LENGTH: "L'ID de la sala ha de tenir 17 caràcters",
	LOGIN: "Iniciar Sessió",
	ROOM_COL: "Sala:",
	LANGUAGE_COL: "Idioma",
	END_ROOM: "Finalitzar Sala",
	JOIN_NOW: "Unir-se Ara",
	LOGIN_FORM: {
		TOAST_TITLE: "Sessió iniciada!",
		TOAST_DESCRIPTION: "Ara pots crear/unir-te a una sala!",
		DISPLAY_NAME: "Nom a Mostrar",
		DISPLAY_NAME_FORM_PLACEHOLDER: "Introdueix el nom visible",
		DISPLAY_NAME_FORM_SHORT:
			"El nom a mostrar ha de tenir com a mínim 3 caràcters",
		DISPLAY_NAME_FORM_LONG:
			"El nom a mostrar ha de tenir com a màxim 32 caràcters",
		DISPLAY_NAME_FORM_REQUIRED: "El nom a mostrar és obligatori",
	},
	PROFILE_FORM: {
		TITLE: "Completa el teu Perfil",
		DESCRIPTION: "Si us plau, introdueix el teu nom a mostrar per començar",
		TOAST_SUCCESS_TITLE: "Perfil Actualitzat!",
		TOAST_SUCCESS_DESCRIPTION: "El teu perfil s'ha desat correctament.",
		TOAST_ERROR_TITLE: "Error d'Actualització",
		TOAST_ERROR_DESCRIPTION:
			"No s'ha pogut actualitzar el teu perfil. Si us plau, torna-ho a provar.",
		SUBMIT_BUTTON: "Desar Perfil",
	},
	DIARIZATION: {
		UNDETECTED: "No detectat",
		ACCURACY: "Precisió",
		ID: "ID",
		LEXICAL: "Lexical",
		ITN: "ITN",
		MASKED_ITN: "ITN màscara",
		LANGUAGE: "Idioma",
		ORIGINAL_TEXT: "Text Original",
		SPEAKER: "Parlant",
	},
	NO_ROOMS_LIST: "Oup, no es pot trobar cap sala.",
	SEARCH_FOR_A_ROOM: "Cercar una sala",
	AUTH_ERROR_DESCRIPTION:
		"Hi ha hagut un problema en autenticar-te. Si us plau, actualitza.",
	DELETE_CONFIRMATION_MODAL: {
		TITLE: "Eliminar Sala",
		DESCRIPTION: "¿Estás seguro de que deseas eliminar esta sala?",
		CANCEL: "Cancelar",
		DELETE: "Eliminar",
	},
	CREATE_ROOM_TOAST: {
		TITLE: "Sala creada",
		DESCRIPTION: "La teva sala està llesta per unir-te.",
	},
	CREATE_ROOM_FORM: {
		DESCRIPTION:
			"Estableix un nom per a la teva sala perquè els altres el vegin.",
		NAME_LABEL: "Nom de la Sala",
		NAME_PLACEHOLDER: "Escriu el nom de la sala",
		LANGUAGE: "Idioma",
		LANGUAGE_PLACEHOLDER: "Selecciona un idioma",
		AUTO_DETECT: "Auto Detectar",
		ENGLISH_US: "Anglès (Estats Units)",
		ENGLISH_IN: "Anglès (Índia)",
		ARABIC_KSA: "Àrab (Aràbia Saudita)",
		SPANISH_CR: "Espanyol (Costa Rica)",
		CATALAN_ES: "Català (Espanya)",
		PORTUGUESE_PT: "Portuguès (Portugal)",
		PORTUGUESE_BR: "Portuguès (Brasil)",
		ESTONIAN_EE: "Estonià (Estònia)",
		RUSSIAN_RU: "Rús (Rússia)",
		MALTESE_MT: "Maltès (Malta)",
		FILIPINO_PH: "Filipí (Filipines)",
		SPANISH_MX: "Espanyol (Mèxic)",
		CHINESE_CN: "Xinès (Mandarí)",
		VIETNAMESE_VN: "Vietnamita (Vietnam)",
		KOREAN_KR: "Coreà (Corea)",
		HINDI_IN: "Hindi (Índia)",
		PERSIAN_IR: "Persa (Iran)",
		LANGUAGE_DESCRIPTION:
			"Selecciona un idioma per a la sala, no podràs canviar l'idioma de la sala més endavant.",
		INCPERSONDEFAULT: "Doe,Jane",
		CDCDEFAULT: "AB1234",
		HEARINGTYPEDEFAULT: "Audiència d'Idoneïtat posterior",
		SCHEDULEDEFAULT: "28/11/2023, 10:30 PST",
		ADVANCED: "Configuració avançada",
		INCARCERATED_PERSON_PLACEHOLDER: "Introdueixi el seu nom",
		CDC_PLACEHOLDER: "Introduïu el número de CDC",
		HEARING_TYPE_PLACEHOLDER: "Introduïu el tipus d'audició",
		INCARCERATED_PERSON: "Persona empresonada",
		CDC: "CDC",
		HEARING_TYPE: "Tipus d'audició",
		SCHEDULE: "Horari",
		PICKDATE: "Tria una data",
		STEP_DETAILS: "Detalls",
		STEP_MODEL: "Model",
		CONTINUE: "Continua",
		BACK: "Enrere",
		MODEL_TITLE: "Model de transcripció",
		MODEL_DESCRIPTION: "Choose the model everyone in this room starts with. You can lock it so participants keep it.",
		LOCK_MODEL: "Lock model for everyone",
		LOCK_MODEL_DESC: "Participants cannot change the transcription model in this room.",
		HOURS: "Hores",
		MINUTES: "Minuts",
		SECONDS: "Segons",
	},
	EXPORT_MODAL: {
		TOAST_FAILED_TITLE: "Exportació Fallida",
		TOAST_FAILED_DESCRIPTION: "No es pot exportar una transcripció buida.",
		DOWNLOAD: "Descarregar",
		DOWNLOAD_DESCRIPTION:
			"Selecciona el format per exportar i habilita opcions addicionals.",
		SELECT_FORMAT: "Selecciona el format",
		SELECT_FORMAT_PLACEHOLDER: "Selecciona el format d'exportació",
		DOCUMENT: "Document (.pdf)",
		SPREADSHEET: "Full de Càlcul (.csv)",
		AUDIO: "Àudio (.mp3)",
		DOCX: "Document Word (.docx)",
	},
	TRANSLATE_DIALOG: {
		TITLE: "Traducció",
		BODY: "Voleu aplicar aquest canvi a totes les transcripcions d'aquest usuari?",
		APPLY_TO_SPEAKER: "Aplica només a aquest usuari",
		APPLY_ONCE: "Aplica només aquí",
		APPLY_TO_ALL: "Aplica a tots els usuaris",

		TRANSLATE: "Traduir",
	},
	GUEST_FORM: {
		TITLE: "Accés de Convidat",
		DESCRIPTION:
			"Introduïu la vostra adreça de correu electrònic per rebre un enllaç d'inici de sessió segur",
		EMAIL_LABEL: "Adreça de Correu Electrònic",
		EMAIL_PLACEHOLDER: "Introdueix l'adreça de correu electrònic",
		EMAIL_REQUIRED: "L'adreça de correu electrònic és obligatòria",
		EMAIL_INVALID:
			"Si us plau, introduïu una adreça de correu electrònic vàlida",
		SEND_LINK: "Enviar Enllaç d'Inici de Sessió",
		SUCCESS_TITLE: "Comproveu el Vostre Correu Electrònic",
		SUCCESS_DESCRIPTION:
			"Hem enviat un enllaç d'inici de sessió a la vostra adreça de correu electrònic. Feu clic a l'enllaç per accedir a la sala.",
		ERROR_TITLE: "Alguna cosa ha anat malament",
		ERROR_DESCRIPTION:
			"No s'ha pogut enviar l'enllaç d'inici de sessió. Si us plau, torneu-ho a provar.",
		CANCEL: "Cancel·lar",
	},
	START_DATE_TIME: "Data i Hora d'Inici",
	END_DATE_TIME: "Data i Hora de Finalització",
	REVERT_TO_ORIGINAL: "Tornar a l'Original",
	SELECTED_LANGUAGE: "Idioma seleccionat",
	TRANSLATION_INFO: "Algunes transcripcions s'han traduït de l'original.",
	INVITE_GUEST: "Convidar Convidat",
	INVITE_GUEST_DESCRIPTION:
		"Convida un usuari convidat a la sala introduint el seu nom i adreça de correu electrònic",
	CREATED_BY: "Creat per",
	VIEW_ALL: "Veure tot",
	LOBBY: {
		LOBBY: "Vestíbul",
		WAITING_IN_LOBBY: "{name} està esperant al vestíbul",
		USERS_WAITING_IN_LOBBY:
			"Gestiona els usuaris que estan esperant actualment al vestíbul.",
		SEND_INVITE: "Enviar invitació",
		ADMIT: "Admetre",
		REJECT: "Rebutjar",
		NO_PARTICIPANTS: "No hi ha participants al vestíbul.",
	},
	CLOSE: "Tancar",

	LOGIN_PAGE: {
		CAROUSEL_STORY_1:
			"Experimenta la transcripció en temps real amb tecnologia avançada de reconeixement de parlants. Perfecte per a reunions, entrevistes i conferències.",
		CAROUSEL_STORY_2:
			"El mode d'alt contrast, les fonts personalitzables i el suport multiidioma garanteixen que tothom pugui utilitzar la nostra plataforma de manera eficaç.",
		CAROUSEL_STORY_3:
			"Les teves converses estan protegides amb seguretat de nivell empresarial. Uneix-te als milers de professionals que confien en uTranscribe.",
		CAROUSEL_STORY_4:
			"Tria el teu mètode d'identificació a continuació i comença a transcriure en segons. No es requereix configuració complexa.",
		CDCR_TEAM_TITLE: "Equip Tech Unicorn",
		CDCR_TEAM_SUBTITLE: "Membre verificat",
		OR_CONTINUE_WITH: "o continua amb",
		GUEST_ACCESS_SUBTITLE:
			"No ets membre? Uneix-te utilitzant el teu ID de reunió",
		WELCOME_TO: "Benvingut a",
		CHOOSE_IDENTIFICATION: "Si us plau, trieu la vostra identificació",
		NEED_HELP:
			"Necessiteu ajuda? Connecteu-vos amb el nostre Servei d'Atenció.",
		CALL_SUPPORT: "Truqueu al 1-877-742-2135",
		EMAIL_SUPPORT: "Envieu un correu a support@courtroom.tech",
	},
	SIZES: "Mides",
	DIAGNOSTICS: "Diagnòstics",
	ROOM_BACKGROUND: "Fons de l'habitació",
	NOT_AVAILABLE: "No disponible",
	UNRECOGNIZED_SPEECH: "No reconegut",
	UNRECOGNIZED_SPEECH_TOOLTIP:
		"Aquesta transcripció no està reconeguda. Si us plau, comprova la qualitat de l'àudio i intenta-ho de nou.",
	UNDETECTED: "No detectat",
	MICROPHONE_QUALITY_WARNING:
		"Si us plau, comprova la qualitat del micròfon per millorar la precisió o ajusta la distància del micròfon",
	LOW_ACCURACY_WARNING: "Precisió baixa",
	UNKNOWN: "Desconegut",
	TRANSCRIPTION_SETTINGS: {
		TRANSCRIPTION_SETTINGS: "Configuració de transcripció",
		GENERAL: "General",
		GENERAL_HINT: "Tema, font i idioma",
		MODE_HINT: "Comportament de transcripció",
		MODEL_HINT: "Motor de processament IA",
		MODE: "Mode",
		LIVE_TRANSCRIPTION: "Transcripció en directe",
		SEGMENTED_TRANSCRIPTION: "Transcripció segmentada",
		FINAL_TRANSCRIPTION: "Transcripció final",
		LIVE_DESC:
			"Visualitza una transcripció en directe del teu propi discurs en un panell separat mentre parles. El panell principal mostra la transcripció final per a tots els oradors.",
		SEGMENTED_DESC:
			"Mostra una transcripció temporal segmentada en temps real, actualitzant-se automàticament a la versió final.",
		FINAL_DESC:
			"Mostra només la transcripció final al panell principal. No es mostra la transcripció en directe.",
		SPEED_VALUE: "Velocitat: {value}x",
		SPEED: "Velocitat",
		FONT_TEST:
			"UTranscribe està revolucionant la manera com capturem i entenem la parla.",
		FONT_SIZE: "Mida de la lletra",
		SPEED_DESC: "Velocitat i retard de la transcripció",
		DELAY_DESC: "Velocitat {speed}x = retard de {delay} segons",
		MODEL: "Model",
		MODEL_TITLE: "Model de Transcripció",
		MODEL_DESC: "Selecciona el model d'IA utilitzat per processar les teves transcripcions.",
		MODEL_DEFAULT: "Predeterminat",
		MODEL_WHISPER: "Allicorn Model 1",
		MODEL_GPT4O: "Allicorn Model 2",
		MODEL_GPT4O_MINI: "Allicorn Model 3",
		MODEL_FAST: "Allicorn Model 4",
		MODEL_DEFAULT_DESC:
			"Servei de diarització de Microsoft amb processament ràpid i precisió fiable per a la majoria de casos d'ús.",
		MODEL_DEFAULT_SHORT_DESC:
			"Diarització de parlants ràpida i fiable per a la majoria de casos d'ús.",
		MODEL_WHISPER_DESC:
			"Allicorn Model 1 amb precisió millorada per a entorns d'àudio complexos i vocabulari especialitzat.",
		MODEL_WHISPER_SHORT_DESC:
			"Alta precisió per a àudio complex i termes especialitzats.",
		MODEL_GPT4O_DESC:
			"Model de transcripció Allicorn Model 2 amb la màxima precisió i comprensió del llenguatge.",
		MODEL_GPT4O_SHORT_DESC:
			"Màxima precisió de transcripció i comprensió del llenguatge.",
		MODEL_GPT4O_MINI_DESC:
			"Model de transcripció Allicorn Model 3 que equilibra precisió i velocitat.",
		MODEL_GPT4O_MINI_SHORT_DESC:
			"Precisió i velocitat de transcripció equilibrades.",
		MODEL_FAST_DESC:
			"Servei de transcripció Allicorn Model 4 optimitzat per a processament de baixa latència.",
		MODEL_FAST_SHORT_DESC:
			"Processament de transcripció de baixa latència.",
		MODEL_ENHANCED: "Millorat",
		MODEL_PREMIUM: "Premium",
		MODEL_BETA: "Beta",
		MODEL_BETA_TOOLTIP: "This feature is currently in beta. Expect occasional inaccuracies as we continue fine-tuning.",
		MODEL_LOCKED: "Model locked",
		MODEL_LOCKED_DESC: "The host fixed the transcription model when this room was created.",
		MODEL_LOCKED_HINT: "Locked by the room host.",
		DOMAIN_MATH_UNAVAILABLE: "Not available for the selected model.",
		DOMAIN_MATH: "Optimitzat per matemàtiques",
		DOMAIN_MATH_DESC:
			"Mostra els símbols i equacions matemàtiques parlades com a notació matemàtica real en lloc de text pla.",
	},
	NO_AUDIO: "No s'ha detectat cap àudio",
	NO_AUDIO_DESC:
		"El teu micròfon no està silenciat però no es detecta cap àudio. Comprova la configuració del micròfon o canvia a un altre micròfon.",
	NO_TRANSCRIPTION: "No s'han generat transcripcions",
	NO_TRANSCRIPTION_DESC:
		"No s'estan generant transcripcions. Si us plau, actualitza la pàgina.",
	SCROLLING_PAUSED: "El desplaçament cap avall està pausat",
	RESUME: "Reprèn",
} satisfies Translation;

export default ca;
